export default __webpack_public_path__ + "static/CT_Home_Sentosa-32fcc871b7981ea89c7847458e9b04c3.png";